<div
    class="card-callouts"
    [ngClass]="{
        'card-callouts--has-border': block.data.cardBorder,
        'card-callouts--no-arrow': block.data.cardArrowIcon,
        'card-callouts--border-small': block.data.cardBorderRadiusSizes === 'small',
        'card-callouts--border-medium': block.data.cardBorderRadiusSizes === 'medium',
        'card-callouts--border-large': block.data.cardBorderRadiusSizes === 'large',
        'card-callouts--bg-color-white': block.data.bgColours === 'white',
        'card-callouts--bg-color-grey': block.data.bgColours === 'grey',
    }">
    @if (block.content.length > 0) {
        <div class="card-callouts__cards">
            @for (card of block.content; track card.id) {
                @if (card.data.heading) {
                    @if (!card.data.isCtaExternalLink) {
                        <!-- Use routerLink for internal links -->
                        <a
                            class="card-callout"
                            [routerLink]="card.data.ctaUrl"
                            [attr.aria-labelledby]="'card-callout-' + card.id">
                            <ng-container *ngTemplateOutlet="cardContents; context: { card: card }"></ng-container>
                        </a>
                    } @else {
                        <!-- href for external links -->
                        <a
                            class="card-callout"
                            [href]="card.data.ctaUrl"
                            [attr.aria-labelledby]="'card-callout-' + card.id"
                            target="_blank">
                            <ng-container *ngTemplateOutlet="cardContents; context: { card: card }"></ng-container>
                        </a>
                    }
                }
            }
        </div>
    }

    @if (block.data.includeCTA) {
        @if (!block.data.isExternalLink) {
            <a
                class="btn btn-primary card-callouts__cta"
                [routerLink]="block.data.ctaLink"
                [innerText]="block.data.ctaLabel"></a>
        } @else {
            <a
                class="btn btn-primary card-callouts__cta"
                [href]="block.data.ctaLink"
                target="_blank"
                [innerText]="block.data.ctaLabel"></a>
        }
    }
</div>

<ng-template #cardContents let-card="card" let-cardImage="cardImage">
    @if (card.data.image) {
        <img class="card-callout__image" [src]="cardImage" [alt]="card.data.heading" />
    }

    <div class="card-callout__content">
        <h2 [id]="'card-callout-' + card.id" class="card-callout__heading">
            <span [innerText]="card.data.heading"></span>
            @if (!block.data.cardArrowIcon) {
                <svg
                    class="ms-2"
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="14"
                    viewBox="0 0 18 14"
                    fill="none">
                    <path
                        d="M1 7H17M11 13L17 7L11 1"
                        stroke="var(--color-primary)"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            }
        </h2>

        @if (card.data.description) {
            <div class="card-callout__description" [innerHTML]="card.data.description"></div>
        }
    </div>
</ng-template>
